import {Form, Formik} from 'formik';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import * as Yup from 'yup';
import DotsLoading from '../../../../../components/dotsLoading';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import ChatHeaderIcon from '../../../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import FloatingOnlySelectBottomSheet from '../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import PrimaryCardAR from '../../../../../module/newShop/advertisementRegisteration/primaryCardAR';
import {
  usePostEmployeeAdvertisement,
  usePostEmployeeRequirements,
  usePostFarmAdvertisement,
  usePostFarmRequirement,
  usePostFertilizerAdvertisement,
  usePostFertilizerRequirement,
  usePostLabRequirement,
  usePostMachineryAdvertisement,
  usePostMachineryRequirement,
  usePostPesticideAdvertisement,
  usePostPesticideRequirement,
  usePostSeedAdvertisement,
  usePostSeedRequirement,
  usePostToolAdvertisement,
  usePostToolRequirement,
} from '../../../../../services/hookService';
import useGetAdCatalog from '../../../../../services/hookService/getAdCatalog/useGetAdCatalog';
import useGetInputUnits from '../../../../../services/hookService/getInputUnits/useGetInputUnits';
import useGetSupplierProfile from '../../../../../services/hookService/getSupplierProfile/useGetSupplierProfile';
import {RootState} from '../../../../../store/redux';
import {
  clearAllData,
  IAdminImagesAdvertisement,
} from '../../../../../store/redux/addPictureAdvertisment';
import {
  addAddType,
  addFormData,
  addOptionalFormData,
  addRegisterAdvertisement,
  resetAllAdvertisementData,
  resetRegisterAdvertisement,
} from '../../../../../store/redux/advertisementRegisteration';
import {ScrollToError} from '../../../../../utilities/helper/scrollToError/ScrollToError';
import {
  convertAdvertisementType,
  getAmountUnits,
  getPriceUnits,
} from '../../../../../utilities/helper/unitGenerator';
import {GroupNameToInputName} from '../../../advertisementList/utils';
import {
  emptyQuantityPack,
  validateExemple,
  validateInitialValue,
} from '../../constants';
import AdvertisementTypesBottomSheet from '../../elements/bottomsheetList/advertisementTypesBottomSheet';
import InputListBottomsheet from '../../elements/bottomsheetList/inputListBottomsheet';
import RentBottomsheet from '../../elements/bottomsheetList/rentBottomSheet';
import ServiceBottomsheet from '../../elements/bottomsheetList/serviceBottomSheet';
import Buy from '../../elements/buy';
import EmptyFarmModal from '../../elements/modal/emptyFarmModal';
import Rent from '../../elements/rent';
import Sale from '../../elements/sale';
import Service from '../../elements/service';
import {IGeneralType} from '../../types';
import {InputGroupCode} from '../../../../../utilities/helper/unitGenerator/unit.types';
import {StoreAccountPlanType} from '../../../../../global/constants/storeType';

const AdvertisementRegisteration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const handleKind = () => {
    if (state.srs_type?.type === 'sell') {
      return 'give';
    } else if (state.srs_type?.type === 'buy') {
      return 'catch';
    } else if (state.srs_type?.type === 'service') {
      if (state.serviceBottomSheetData === 'providedService') {
        return 'give';
      } else {
        return 'catch';
      }
    } else if (state.srs_type?.type === 'rent') {
      if (state.rentBottomSheetData === 'providedRent') {
        return 'give';
      } else {
        return 'catch';
      }
    }
  };

  const payload = {
    input_guid: state.input?.guid,
    operation_type: state.srs_type?.type,
    kind: handleKind(),
  };

  const {unitData, unitsIsLoading} = useGetInputUnits(payload);
  const {cropedImage, adminImages} = useSelector(
    (state: RootState) => state.addPictureAdvertisement,
  );

  const handleAfterSuccess = (data: IProfile) => {
    if (!state?.input_group?.guid) {
      if (
        data?.supplier_profile?.lab?.guid ||
        data?.supplier_profile?.store?.guid
      ) {
        dispatch(addAddType({title: 'آگهی فروشگاهی', value: 'store'}));
      } else {
        dispatch(addAddType({title: 'آگهی شخصی', value: 'personal'}));
      }
    }
  };

  const {data: user, isLoading} = useGetSupplierProfile({handleAfterSuccess});

  const {addCatalogData, catalogDataIsLoading} = useGetAdCatalog({});

  const [openInputListBottomSheet, setOpenInputListBottomSheet] =
    useState<boolean>(false);
  const [openRentBottomsheet, setOpenRentBottomsheet] =
    useState<boolean>(false);
  const [openServiceBottomsheet, setOpenServiceBottomsheet] =
    useState<boolean>(false);
  const [
    openAdvertisementTypeBottomSheet,
    setOpenAdvertisementTypeBottomSheet,
  ] = useState<boolean>(false);
  const [isEmptyFarmModal, setIsEmptyFarmModal] = useState<boolean>(false);

  const HandleAfterSuccess = (response?: IAddedAdvertisementResponse) => {
    dispatch(addOptionalFormData(''));
    dispatch(resetAllAdvertisementData());
    dispatch(clearAllData());
    dispatch(addFormData(''));
    navigate('/home', {state: response});
  };

  //* ==================================================================== POST FERTILIZER

  const {
    mutate: mutateFertilizerAdvertisement,
    isLoading: fertilizerIsLoading,
  } = usePostFertilizerAdvertisement({
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });

  //* ==================================================================== POST PESTICIDE

  const {mutate: mutatePesticideAdvertisement, isLoading: pesticideIsLoading} =
    usePostPesticideAdvertisement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  //* ==================================================================== POST SEED

  const {mutate: mutateSeedAdvertisement, isLoading: seedIsLoading} =
    usePostSeedAdvertisement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  //* ==================================================================== POST MACHINERY

  const {mutate: mutateMachineryAdvertisement, isLoading: machineryIsLoading} =
    usePostMachineryAdvertisement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  //* ==================================================================== POST TOOLS

  const {mutate: mutateToolAdvertisement, isLoading: toolIsLoading} =
    usePostToolAdvertisement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  //* ==================================================================== POST FARM (no brand field, it's null)

  const {mutate: mutateFarmAdvertisement, isLoading: FarmIsLoading} =
    usePostFarmAdvertisement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  const {mutate: mutateEmployeeAdvertisement, isLoading: employeeIsLoading} =
    usePostEmployeeAdvertisement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  // ---------------------- REQUIREMENTS ---------------------- //

  const {
    mutate: mutateFertilizerRequirement,
    isLoading: requirementFertilizerIsLoading,
  } = usePostFertilizerRequirement({
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {
    mutate: mutatePesticideRequirement,
    isLoading: requirementPersticideIsLoading,
  } = usePostPesticideRequirement({
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateSeedRequirement, isLoading: requirementSeedIsLoading} =
    usePostSeedRequirement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });
  const {
    mutate: mutateMachineryRequirement,
    isLoading: requirementMachineryIsLoading,
  } = usePostMachineryRequirement({
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });
  const {mutate: mutateToolRequirement, isLoading: requirementToolIsLoading} =
    usePostToolRequirement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });
  const {
    mutate: mutateEmployeeRequirement,
    isLoading: requirementEmployeeIsLoading,
  } = usePostEmployeeRequirements({
    onSuccess: data => {
      HandleAfterSuccess(data);
    },
  });

  const {mutate: mutateFarmRequirement, isLoading: requirementFarmIsLoading} =
    usePostFarmRequirement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  const {mutate: mutateLabRequirement, isLoading: requirementLabIsLoading} =
    usePostLabRequirement({
      onSuccess: data => {
        HandleAfterSuccess(data);
      },
    });

  const loading =
    seedIsLoading ||
    toolIsLoading ||
    FarmIsLoading ||
    employeeIsLoading ||
    machineryIsLoading ||
    pesticideIsLoading ||
    fertilizerIsLoading ||
    requirementLabIsLoading ||
    requirementSeedIsLoading ||
    requirementFarmIsLoading ||
    requirementToolIsLoading ||
    requirementEmployeeIsLoading ||
    requirementMachineryIsLoading ||
    requirementPersticideIsLoading ||
    requirementFertilizerIsLoading;

  const actionFn = (props: IGeneralType) => {
    if (state?.input_group) {
      if (state?.srs_type.type === 'sale') {
        if (state?.input_group.type === 'fertilizer') {
          return mutateFertilizerAdvertisement({...props});
        } else if (state?.input_group.type === 'pesticide') {
          return mutatePesticideAdvertisement({...props});
        } else if (state?.input_group.type === 'seed') {
          return mutateSeedAdvertisement({...props});
        } else if (state?.input_group.type === 'machinery') {
          return mutateMachineryAdvertisement({...props});
        } else if (state?.input_group.type === 'tool') {
          return mutateToolAdvertisement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeAdvertisement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmAdvertisement({...props});
        }
      }
      if (state?.srs_type.type === 'buy') {
        if (state?.input_group.type === 'fertilizer') {
          return mutateFertilizerRequirement({...props});
        } else if (state?.input_group.type === 'pesticide') {
          return mutatePesticideRequirement({...props});
        } else if (state?.input_group.type === 'seed') {
          return mutateSeedRequirement({...props});
        } else if (state?.input_group.type === 'machinery') {
          return mutateMachineryRequirement({...props});
        } else if (state?.input_group.type === 'tool') {
          return mutateToolRequirement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeRequirement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmRequirement({...props});
        }
      }
      if (
        state?.srs_type.type === 'service' &&
        state?.serviceBottomSheetData === 'providedService'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryAdvertisement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeAdvertisement({...props});
        }
      }
      if (
        state?.srs_type.type === 'service' &&
        state?.serviceBottomSheetData === 'wantedService'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryRequirement({...props});
        } else if (state?.input_group.type === 'employee') {
          return mutateEmployeeRequirement({...props});
        } else if (state?.input_group.type === 'lab') {
          return mutateLabRequirement({...props});
        }
      }
      if (
        state?.srs_type.type === 'rent' &&
        state?.rentBottomSheetData === 'providedRent'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryAdvertisement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmAdvertisement({...props});
        }
      }
      if (
        state?.srs_type.type === 'rent' &&
        state?.rentBottomSheetData === 'wantedRent'
      ) {
        if (state?.input_group.type === 'machinery') {
          return mutateMachineryRequirement({...props});
        } else if (state?.input_group.type === 'farm') {
          return mutateFarmRequirement({...props});
        }
      }
    }
  };

  const handleSchema = () => {
    if (state?.srs_type && state?.input_group && state?.input) {
      if (state?.srs_type?.type === 'rent' && state?.rentBottomSheetData) {
        return Yup.object().shape({
          ...validateExemple(state?.input?.title)[
            state?.rentBottomSheetData +
              state?.input_group?.code +
              state?.input?.code
          ],
        });
      } else if (
        state?.srs_type?.type === 'service' &&
        state?.serviceBottomSheetData
      ) {
        return Yup.object().shape({
          ...validateExemple(state?.input?.title)[
            state?.serviceBottomSheetData +
              state?.input_group?.code +
              state?.input?.code
          ],
        });
      } else if (state?.input_group?.code === InputGroupCode.FARM) {
        return Yup.object().shape({
          ...validateExemple(state?.input?.title)[
            state?.srs_type?.type +
              state?.input_group?.code +
              state?.input?.code
          ],
        });
      } else {
        return Yup.object().shape({
          ...validateExemple(
            state?.input?.title,
            state.input_group.type &&
              GroupNameToInputName[state.input_group.type],
          )[state?.srs_type?.type + state?.input_group?.code],
        });
      }
    } else {
      return Yup.object().shape({});
    }
  };

  // fills the input unit value initial values at the start
  const handleInitialValue = () => {
    const subType = (state?.rentBottomSheetData ??
      state?.serviceBottomSheetData) as any;

    const inputValueUnits = getAmountUnits(
      convertAdvertisementType(state?.srs_type?.type)!,
      state?.input_group?.code as number,
      state?.input?.code as number,
      state?.sub_input?.code as number,
    );
    const inputPriceUnits = getPriceUnits(
      convertAdvertisementType(state?.srs_type?.type, subType)!,
      state?.input_group?.code as number,
      state?.input?.code,
    );

    if (state?.srs_type && state?.input_group && state?.input) {
      if (state?.srs_type?.type === 'rent' && state?.rentBottomSheetData) {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.rentBottomSheetData +
            state?.input_group?.code +
            state?.input?.code
        ];
      } else if (
        state?.srs_type?.type === 'service' &&
        state?.serviceBottomSheetData
      ) {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.serviceBottomSheetData +
            state?.input_group?.code +
            state?.input?.code
        ];
      } else if (state?.input_group?.code === InputGroupCode.FARM) {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.srs_type?.type + state?.input_group?.code + state?.input?.code
        ];
      } else {
        return validateInitialValue(inputValueUnits, inputPriceUnits)[
          state?.srs_type?.type + state?.input_group?.code
        ];
      }
    } else {
      return Yup.object().shape({});
    }
  };

  const handleMainImage = (
    cropedImage: IAdminImagesAdvertisement[] | null,
    adminImages: IAdminImagesAdvertisement[] | null,
  ) => {
    const selectedUserMainImg = cropedImage?.find(item => item.flag)
      ? cropedImage?.find(item => item.flag)?.id
      : null;
    const selectedAdminMainImg = adminImages?.find(item => item.flag)
      ? adminImages?.find(item => item.flag)?.id
      : null;

    if (selectedUserMainImg)
      return {
        main_image: cropedImage?.find(item => item.flag)
          ? cropedImage?.find(item => item.flag)?.id
          : null,
      };
    if (selectedAdminMainImg)
      return {
        sub_brand_main_image: adminImages?.find(item => item.flag)
          ? adminImages?.find(item => item.flag)?.id
          : null,
      };

    return null;
  };
  useEffect(() => {
    if (state?.mode === 'edit') {
      dispatch(addOptionalFormData(''));
      dispatch(resetRegisterAdvertisement({}));
      dispatch(clearAllData());
      dispatch(addFormData(''));
    } else {
      dispatch(addRegisterAdvertisement({...state, mode: 'create'}));
    }
  }, [dispatch, state.mode]);

  const parsedFormData = state.formData && JSON.parse(state.formData);
  const isLab = user?.supplier_profile?.lab;
  const storePlanType =
    (isLab ? 120 : user?.supplier_profile?.store?.store_type?.code) ??
    StoreAccountPlanType.NoStore;

  return (
    <div className="flex flex-col h-full">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        title="ثبت آگهی"
        isActiveRightIcon={true}
        onClick={() => {
          dispatch(addOptionalFormData(''));
          dispatch(resetAllAdvertisementData());
          dispatch(clearAllData());
          dispatch(addFormData(''));
          navigate('/');
        }}
        postComponent={() => (
          <div className="flex gap-3">
            <NotificationHeaderIcon />
            <ChatHeaderIcon />
          </div>
        )}
      />

      {isLoading || unitsIsLoading ? (
        <div className="flex justify-center items-center h-full">
          <DotsLoading />
        </div>
      ) : (
        <Formik
          initialValues={{
            ...handleInitialValue(),
            ...(state.formData && JSON.parse(state.formData)),
            sub_input: {
              title: state?.sub_input?.title,
              guid: state?.sub_input?.guid,
            },
            title:
              state.title ??
              state?.sub_brand_data?.advertisement_title ??
              parsedFormData?.title,
            type: state?.type ?? parsedFormData?.type,

            description:
              state.description ??
              state?.sub_brand_data?.advertisement_description,

            ad_price:
              state?.price ??
              state?.sub_brand_data?.ad_price ??
              parsedFormData?.ad_price,
            selectedMainImg: parsedFormData?.selectedMainImg ?? null,
            hasImages: false,
            location: {
              lat:
                user &&
                user?.supplier_profile &&
                user?.supplier_profile?.latlong
                  ? user?.supplier_profile?.latlong[0]
                  : user?.farmer_profile && user?.farmer_profile?.latlong
                  ? user?.farmer_profile?.latlong[0]
                  : 0,
              lng:
                user &&
                user?.supplier_profile &&
                user?.supplier_profile?.latlong
                  ? user?.supplier_profile?.latlong[1]
                  : user?.farmer_profile && user?.farmer_profile?.latlong
                  ? user?.farmer_profile?.latlong[1]
                  : undefined,
            },
            has_no_brand: state?.has_no_brand ?? false,
            min_sell_quantity:
              state?.min_sell_quantity ?? parsedFormData?.min_sell_quantity,
            available_quantity:
              state?.available_quantity ?? parsedFormData?.available_quantity,
            combinations: state?.combinations ?? parsedFormData?.combinations,
            application_method:
              state?.application_method ?? parsedFormData?.application_method,
            quantity_pack_unit:
              state?.quantity_pack_unit ??
              parsedFormData?.quantity_pack_unit ??
              handleInitialValue()?.quantity_pack_unit ??
              emptyQuantityPack.quantity_pack_unit,
            quantity_pack:
              state?.quantity_pack ??
              parsedFormData?.quantity_pack ??
              handleInitialValue()?.quantity_pack ??
              emptyQuantityPack.quantity_pack,
          }}
          enableReinitialize
          validationSchema={handleSchema()}
          validateOnBlur={true} // Validate when fields lose focus
          validateOnChange={true} // Validate on every keystroke
          onSubmit={async (values, {setSubmitting}) => {
            const payload = {
              ...JSON.parse(state?.optionalFormData || '""'),
              ...JSON.parse(state?.formData || '""'),
              ad_type: state?.ad_type?.value,
              srs_type: state?.srs_type,
              ...(state?.input_group?.code === 17 &&
                state?.input?.code === 11 && {type: 'dry_land'}),
              ...(state?.input_group?.code === 17 &&
                state?.input?.code === 13 && {type: 'irrigated_land'}),
              ...(state?.input_group?.code === 15 &&
                state?.input?.code === 11 && {type: 'machinery'}),
              ...(state?.input_group?.code === 15 &&
                state?.input?.code === 17 && {type: 'sequence'}),
              is_change_title: state?.is_change_title,
              sub_brand_images: adminImages?.map(img => img.id),
              images: cropedImage?.map(item => item.id) || null,
              sub_brand: state?.sub_brand_data?.id,
              ...handleMainImage(cropedImage, adminImages),
            };
            try {
              actionFn(payload);
            } catch (error) {
              console.error('Form validation error:', error);
              setSubmitting(false);
            }
          }}
        >
          {({setFieldValue, values, errors, isValid, submitCount}) => {
            return (
              <Form className="flex overflow-y-auto relative flex-col w-full h-full">
                {/* Component to scroll to Error */}
                <ScrollToError errors={errors} submitCount={submitCount} />
                <div className="flex flex-col px-3 py-3 w-full h-full">
                  <section>
                    <FloatingOnlySelectBottomSheet
                      value={state?.ad_type?.title}
                      title="نوع آگهی"
                      onClick={() => {
                        dispatch(
                          addRegisterAdvertisement({
                            srs_type: undefined,
                            input_group: undefined,
                            input: undefined,
                          }),
                        );
                        dispatch(clearAllData());
                        setOpenAdvertisementTypeBottomSheet(true);
                        setOpenRentBottomsheet(false);
                        setOpenServiceBottomsheet(false);
                        dispatch(
                          addRegisterAdvertisement({
                            serviceBottomSheetData: '',
                          }),
                        );
                        dispatch(
                          addRegisterAdvertisement({
                            rentBottomSheetData: '',
                          }),
                        );
                      }}
                    />
                    <p className="mt-3 text-md">
                      یکی از انواع آگهی را انتخاب کنید.
                    </p>
                    <div>
                      {catalogDataIsLoading ? (
                        <div className="flex justify-center items-center h-full">
                          <DotsLoading />
                        </div>
                      ) : (
                        <div className="grid grid-cols-2 gap-2">
                          {addCatalogData?.map((item: IAdCatalog, index) => (
                            <PrimaryCardAR
                              key={item.code ?? index}
                              title={item.title}
                              image={item.image}
                              onClick={() => {
                                dispatch(
                                  addRegisterAdvertisement({
                                    srs_type: {
                                      image: item.image,
                                      title: item.title,
                                      type: item.operation_type,
                                    },
                                    input_group: undefined,
                                    input: undefined,
                                  }),
                                );
                                dispatch(clearAllData());
                                if (item.operation_type === 'rent') {
                                  setOpenRentBottomsheet(true);
                                } else if (item.operation_type === 'service') {
                                  setOpenServiceBottomsheet(true);
                                }
                              }}
                              active={item.title === state.srs_type?.title}
                              disabled={
                                state?.ad_type?.value === 'store' &&
                                item.operation_type === 'buy'
                              }
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  </section>
                  {state.srs_type?.type === 'sale' && (
                    //* =================================================================
                    //   ------------------------ Sale --------------------------------
                    //* =================================================================

                    <Sale
                      storePlanType={storePlanType!}
                      srs_type={state.srs_type}
                      setOpenInputListBottomSheet={setOpenInputListBottomSheet}
                      isLoading={loading}
                      setIsEmptyFarmModal={setIsEmptyFarmModal}
                      guid={
                        addCatalogData?.find(
                          item => item.operation_type === 'sale',
                        )?.guid
                      }
                      unitData={unitData}
                    />
                  )}
                  {state.srs_type?.type === 'buy' && (
                    //* =================================================================
                    //   ------------------------- Buy --------------------------------
                    //* =================================================================

                    <Buy
                      storePlanType={storePlanType}
                      srs_type={state.srs_type}
                      setOpenInputListBottomSheet={setOpenInputListBottomSheet}
                      // setModalText={setModalText}
                      guid={
                        addCatalogData?.find(
                          item => item.operation_type === 'buy',
                        )?.guid
                      }
                      isLoading={loading}
                      unitData={unitData}
                    />
                  )}
                  {state.srs_type?.type === 'rent' && (
                    //* =================================================================
                    //   ------------------------ Rent --------------------------------
                    //* =================================================================

                    <Rent
                      storePlanType={storePlanType!}
                      srs_type={state.srs_type}
                      setOpenInputListBottomSheet={setOpenInputListBottomSheet}
                      guid={
                        addCatalogData?.find(
                          item => item.operation_type === 'rent',
                        )?.guid
                      }
                      isLoading={loading}
                      unitData={unitData}
                    />
                  )}
                  {state.srs_type?.type === 'service' && (
                    //* =================================================================
                    //   ----------------------- Service ------------------------------
                    //* =================================================================

                    <Service
                      storePlanType={storePlanType!}
                      srs_type={state.srs_type}
                      setOpenInputListBottomSheet={setOpenInputListBottomSheet}
                      guid={
                        addCatalogData?.find(
                          item => item.operation_type === 'service',
                        )?.guid
                      }
                      isLoading={loading}
                      unitData={unitData}
                    />
                  )}
                </div>

                <InputListBottomsheet
                  {...{
                    openInputListBottomSheet,
                    setOpenInputListBottomSheet,
                  }}
                  srs_type={state?.srs_type}
                />

                {state?.ad_type?.value !== 'store' &&
                  openRentBottomsheet === true && (
                    <RentBottomsheet
                      {...{
                        openRentBottomsheet,
                        setOpenRentBottomsheet,
                      }}
                    />
                  )}
                {state?.ad_type?.value !== 'store' &&
                  openServiceBottomsheet === true && (
                    <ServiceBottomsheet
                      {...{
                        openServiceBottomsheet,
                        setOpenServiceBottomsheet,
                      }}
                    />
                  )}
                <AdvertisementTypesBottomSheet
                  {...{
                    openAdvertisementTypeBottomSheet,
                    setOpenAdvertisementTypeBottomSheet,
                  }}
                />
                {!state?.srs_type && (
                  <span className="pb-3 mx-auto text-xs text-gray-700">
                    آگهی منتشر شده، پس از ۳ ماه منقضی می‌شود.
                  </span>
                )}
              </Form>
            );
          }}
        </Formik>
      )}

      <MainFooter />

      <EmptyFarmModal {...{isEmptyFarmModal, setIsEmptyFarmModal}} />
    </div>
  );
};

export default AdvertisementRegisteration;
